export const runScanValues = {
    link: '',
};
